// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__ySY3C","modal__close":"styles_modal__close__ZY4UV","modal__round":"styles_modal__round__0t+NF","modal__buttons":"styles_modal__buttons__7TkH+"};